import { render, staticRenderFns } from "./IncomeFull.vue?vue&type=template&id=0dc267b2"
import script from "./IncomeFull.vue?vue&type=script&lang=js"
export * from "./IncomeFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports